/**
 * Nome do produto exibido no título da aba. Vertto por padrão; um preset de org
 * (src/lib/orgPresets.ts) troca o valor via `useApplyOrgBranding`.
 *
 * Variável de módulo e não contexto: quem escreve `document.title` são efeitos espalhados
 * (PageHeader, badge de não lidas) que só precisam ler o nome no momento em que rodam.
 */
export const DEFAULT_APP_TITLE = 'Vertto CRM';

let appTitle = DEFAULT_APP_TITLE;

export function getAppTitle(): string {
  return appTitle;
}

export function setAppTitle(title: string | null | undefined): void {
  appTitle = title || DEFAULT_APP_TITLE;
}
